const GET_REGION_DROP_DOWN_LIST = 'GET_REGION_DROP_DOWN_LIST';
const SET_REGION_DROP_DOWN_LIST = 'SET_REGION_DROP_DOWN_LIST';
const GET_REGIONS = 'GET_REGIONS';
const SET_REGIONS = 'SET_REGIONS';
export {
    GET_REGION_DROP_DOWN_LIST,
    SET_REGION_DROP_DOWN_LIST,
    GET_REGIONS,
    SET_REGIONS
};